module.exports = __webpack_public_path__ + "static/media/settings.a2418482.svg";